import { render, staticRenderFns } from "./CenterViewEventManagement_Ap.vue?vue&type=template&id=bb850bb2&scoped=true"
import script from "./CenterViewEventManagement_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventManagement_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventManagement_Ap.vue?vue&type=style&index=0&id=bb850bb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb850bb2",
  null
  
)

export default component.exports